import ReloadConfirmationCard from "Components/ServiceWorker/ReloadConfirmationCard/ReloadConfirmationCard";
import { Toast } from "lexus-style-guide/Components/Toast/Toast";
import { FC, PropsWithChildren } from "react";

interface Props {
    isOpen: boolean;
    onYes: () => void;
}

type ToastWithChildrenProps = PropsWithChildren<{
    isOpen: boolean;
    onClose?: () => void;
    hideClose?: boolean;
    contentClass?: string;
    shouldCloseOnOverlayClick?: boolean;
    title?: string;
}>;

const ToastWithChildren = Toast as FC<ToastWithChildrenProps>;

const ConfirmationToast: FC<Props> = ({ isOpen, onYes }) => (
    <ToastWithChildren isOpen={isOpen} hideClose={true}>
        <ReloadConfirmationCard onYes={onYes} />
    </ToastWithChildren>
);

const ServiceWorkerReload: FC<Props> = ({ isOpen, onYes }) => {
    return <ConfirmationToast isOpen={isOpen} onYes={onYes} />;
};

export default ServiceWorkerReload;
